import { collection, getDocs } from 'firebase/firestore';

import { db } from '../../config';

export const fetchCollectionDocuments = async <T>(
  collectionPath: string,
): Promise<(T & { id: string })[]> => {
  try {
    const collectionRef = collection(db, collectionPath);
    const snapshot = await getDocs(collectionRef);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...(doc.data() as T),
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    throw error;
  }
};
